import { BookingV2BerthOccupancy } from '../dtos/booking-v2.dtos';
import { BookingV2DateRange } from '../services/booking-v2.facade';

export function bookingV2DatesEqual(a: Date | null | undefined, b: Date | null | undefined): boolean {
    if (a == null && b == null) {
        return true;
    }
    if (a == null || b == null) {
        return false;
    }
    return a.getTime() === b.getTime();
}

/** True when a berth occupancy window matches the booking-level date range (#6989). */
export function occupancyMatchesBookingDateRange(
    occFrom: Date | null,
    occTo: Date | null,
    occOpenEnd: boolean,
    range: BookingV2DateRange,
): boolean {
    if (!bookingV2DatesEqual(occFrom, range.from)) {
        return false;
    }
    if (occOpenEnd !== range.openEnd) {
        return false;
    }
    if (range.openEnd) {
        return occTo == null;
    }
    return bookingV2DatesEqual(occTo, range.to);
}

export function syncOccupanciesToBookingDateRange(
    occupancies: readonly BookingV2BerthOccupancy[],
    range: BookingV2DateRange,
): readonly BookingV2BerthOccupancy[] {
    let changed = false;
    const next = occupancies.map(o => {
        if (o.overridden) {
            return o;
        }
        if (
            bookingV2DatesEqual(o.from, range.from)
            && bookingV2DatesEqual(o.to, range.to)
            && o.openEnd === range.openEnd
        ) {
            return o;
        }
        changed = true;
        return { ...o, from: range.from, to: range.to, openEnd: range.openEnd };
    });
    return changed ? next : occupancies;
}

/** Commit window: non-overridden occupancies always follow the date-step range. */
export function resolveOccupancyCommitWindow(
    occ: BookingV2BerthOccupancy,
    range: BookingV2DateRange,
): { from: Date | null; to: Date | null } {
    const bookingFrom = range.from;
    const bookingTo = range.openEnd ? null : range.to;

    if (!occ.overridden) {
        return { from: bookingFrom, to: bookingTo };
    }

    return {
        from: occ.from ?? bookingFrom,
        to: occ.openEnd ? null : (occ.to ?? bookingTo),
    };
}
